var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrainPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 45,
    viewBox: "0 0 232 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pattern"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 472",
    x: 112,
    y: 21,
    width: 120,
    height: 3,
    fill: "#E3D1BE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 13",
    d: "M101.485 25.4708C102.61 23.471 101.165 21 98.8705 21L90.5 21L79.3435 40.8338C78.2952 42.6974 79.6419 45 81.78 45C87.1666 45 92.1343 42.0946 94.7751 37.3999L101.485 25.4708Z",
    fill: "#E3D1BE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 80",
    d: "M70.4852 25.4708C71.6101 23.471 70.1649 21 67.8705 21L59.5 21L48.3435 40.8338C47.2952 42.6974 48.6419 45 50.78 45C56.1666 45 61.1343 42.0946 63.7751 37.3999L70.4852 25.4708Z",
    fill: "#E3D1BE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 82",
    d: "M39.4852 25.4708C40.6101 23.471 39.1649 21 36.8705 21L28.5 21L17.3435 40.8338C16.2952 42.6974 17.6419 45 19.78 45C25.1666 45 30.1343 42.0946 32.7751 37.3999L39.4852 25.4708Z",
    fill: "#E3D1BE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 79",
    d: "M86.4852 19.5292C87.6101 21.529 86.1649 24 83.8705 24L75.5 24L64.3435 4.16617C63.2952 2.30261 64.6419 9.80647e-07 66.78 1.39684e-06C72.1666 2.44535e-06 77.1343 2.90536 79.7751 7.60011L86.4852 19.5292Z",
    fill: "#E3D1BE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 81",
    d: "M55.4852 19.5292C56.6101 21.529 55.1649 24 52.8705 24L44.5 24L33.3435 4.16617C32.2952 2.30261 33.6419 9.80647e-07 35.78 1.39684e-06C41.1666 2.44535e-06 46.1343 2.90536 48.7751 7.60011L55.4852 19.5292Z",
    fill: "#E3D1BE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 83",
    d: "M24.4852 19.5292C25.6101 21.529 24.1649 24 21.8705 24L13.5 24L2.34347 4.16617C1.29522 2.30261 2.64189 9.80647e-07 4.78004 1.39684e-06C10.1666 2.44535e-06 15.1343 2.90536 17.7751 7.60011L24.4852 19.5292Z",
    fill: "#E3D1BE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrainPattern);
export default __webpack_public_path__ + "static/media/grain-pattern.f82931668bbdb1197a59bec1c3bcdfad.svg";
export { ForwardRef as ReactComponent };